export default __webpack_public_path__ + "static/media/Daggamalt.3cc09a7b.jpg";